module.exports = ".avatar {\n  padding: 1em 0;\n  margin: 0 auto;\n}\n.avatar .image-wrapper {\n  width: 175px;\n  height: 175px;\n  border-radius: 100%;\n  border: 1px solid #777;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.avatar .image {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/avatar/avatar.component.less
// module id = ./src/app/avatar/avatar.component.less
// module chunks = main